module.exports = __webpack_public_path__ + "static/img/icon-brand.85c4118.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/promotion/icon-brand.svg
// module id = jgOX
// module chunks = 156